var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment method icon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mastercard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Left",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.179 17.3288C15.9949 18.3268 14.459 18.9293 12.7807 18.9293C9.03582 18.9293 6 15.9296 6 12.2293C6 8.52899 9.03582 5.5293 12.7807 5.5293C14.459 5.5293 15.9949 6.13179 17.179 7.12984C18.363 6.13179 19.8989 5.5293 21.5773 5.5293C25.3221 5.5293 28.358 8.52899 28.358 12.2293C28.358 15.9296 25.3221 18.9293 21.5773 18.9293C19.8989 18.9293 18.363 18.3268 17.179 17.3288Z",
    fill: "#ED0006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.179 17.3288C18.6369 16.0999 19.5614 14.2713 19.5614 12.2293C19.5614 10.1873 18.6369 8.35874 17.179 7.12984C18.363 6.13179 19.8989 5.5293 21.5773 5.5293C25.3221 5.5293 28.3579 8.52899 28.3579 12.2293C28.3579 15.9296 25.3221 18.9293 21.5773 18.9293C19.8989 18.9293 18.363 18.3268 17.179 17.3288Z",
    fill: "#F9A000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Middle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.179 17.3278C18.6369 16.0989 19.5614 14.2703 19.5614 12.2283C19.5614 10.1864 18.6369 8.35781 17.179 7.12891C15.7211 8.35781 14.7966 10.1864 14.7966 12.2283C14.7966 14.2703 15.7211 16.0989 17.179 17.3278Z",
    fill: "#FF5E00"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F2F4F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.92fcf948a3a8031a083bec6b0123a0ce.svg";
export { ForwardRef as ReactComponent };